package one.healthium.ui.compose.utils

actual fun targetPlatform() = TargetPlatform.Web